<template>
    <div class="vx-col w-full md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
        <vx-card :title="data.title">
            <!-- CARD ACTION -->
            <template slot="actions">
                <change-time-duration-dropdown />
            </template>

            <div slot="no-body" v-if="data.chartData.analyticsData">
                <div class="vx-row text-center">

                    <!-- Open Tickets Heading -->
                    <div class="vx-col w-full lg:w-1/5 md:w-full sm:w-1/5 flex flex-col justify-between mb-4 lg:order-first md:order-last sm:order-first order-last">
                        <div class="lg:ml-6 lg:mt-6 md:mt-0 md:ml-0 sm:ml-6 sm:mt-6">
                            <h1 class="font-bold text-5xl">{{ data.chartData.analyticsData.openTickets }}</h1>
                            <small>Tickets</small>
                        </div>
                    </div>

                    <!-- Chart -->
                    <div class="vx-col w-full lg:w-4/5 md:w-full sm:w-4/5 justify-center mx-auto lg:mt-0 md:mt-6 sm:mt-0 mt-6">
                        <vue-apex-charts type=radialBar height=385 :options="data.chartData.chartOptions" :series="data.chartData.series" />
                    </div>
                </div>

                <!-- Support Tracker Meta Data -->
                <div class="flex flex-row justify-between px-8 pb-4 mt-4">
                    <p class="text-center" v-for="(val, key) in data.chartData.analyticsData.meta" :key="key">
                        <span class="block">{{ key }}</span>
                        <span class="text-2xl font-semibold">{{ val }}</span>
                    </p>
                </div>
            </div>
        </vx-card>
    </div>
</template>

<script>

    import VueApexCharts from 'vue-apexcharts'
    import ChangeTimeDurationDropdown from '@/components/ChangeTimeDurationDropdown.vue'

    export default {
        name: "radial-bar",
        props: {
            data: Object
        },
        components: {
            ChangeTimeDurationDropdown,
            VueApexCharts
        }
    };
</script>
